<h1 class="page-title">Gyermekfoglalkozások</h1>

<!--img:Gyermekfoglalkozás Pillanatkép a középső csoportból-->

<p>Istentiszteleteink alatt 3 korosztályban, 3 külön csoportban tartunk foglalkozásokat gyermekeknek:</p>

<ul>
  <li>A legkisebbeknek csupa játékkal telik el az idő.</li>
  <li>Nagyobb ovisoknak és kisiskolásoknak 10-15 percben tanítás van a bibliából, az ő szintjükön, utána pedig kézműves
    és csoportos játékok következnek.
  </li>
  <li>3. osztályos kortól előbb 30 perc tanítás van, amiről aztán beszélgetnek, végül itt is szokott lenni valamilyen
    csoportos játék.
  </li>
</ul>

<p>Szeretettel várunk minden gyermeket vasárnaponként 16 órától!</p>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/sunday-school/sunday-school.component.html